export default __webpack_public_path__ + "static/media/thetriumphofdeath.b4eb53cc.jpg";